<template>
  <div class="container" v-if="evaluationDataLoaded && applicationDataLoaded">
    <div class="level">
      <div class="level-left">
        <div class="level-item">
          <h4 class="title is-4">
            {{ application.organization.name }}
            <span
              class="tag is-primary"
              v-if="application.isEvaluatedByUser"
              style="margin: 0 10px"
            >
              Completed
            </span>
          </h4>
        </div>
      </div>
      <div class="level-right">
        <div class="level-item">
          <button
            class="button"
            @click="showProposal = !showProposal"
            :class="{ 'is-primary': showProposal }"
          >
            {{ showProposal ? 'Hide Proposal' : 'Show Proposal' }}
          </button>
        </div>
        <div class="level-item">
          <button
            class="button"
            @click="showEvaluation = !showEvaluation"
            :class="{ 'is-primary': showEvaluation }"
          >
            {{ showEvaluation ? 'Hide Evaluation' : 'Show Evaluation' }}
          </button>
        </div>
        <div class="level-item"  v-if="user.is_staff">
          <button class="button is-primary" 
           @click="toViewEvaluationVersion(application.id)">
            God Mode
          </button>
        </div>

      </div>
    </div>
    <div class="columns">
      <div class="column" v-if="!showEvaluation && !showProposal">
        <div class="content">
          Everything is hidden! Click one of the buttons above to un-hide either the proposal or the
          evaluation.
        </div>
      </div>
      <div class="column is-half" v-if="showProposal">
        <h4 class="title is-4">Their Submitted Proposal</h4>
        <div class="content">
          <table class="table is-bordered propTable">
            <tbody>
              <tr>
                <th>Project Name</th>
                <td class="has-text-centered">{{ application.projectName }}</td>
              </tr>
              <tr>
                <th>Organization Type</th>
                <td class="has-text-centered">{{ application.questionOrganizationType }}</td>
              </tr>
              <tr>
                <th>Organization Website</th>
                <td class="has-text-centered">{{ application.questionOrganizationWebsite }}</td>
              </tr>
              <tr>
                <th>Organization Submitted To</th>
                <td class="has-text-centered">{{ application.organizationSubmittedTo }}</td>
              </tr>
              <!-- <tr>
               <th>Applicant Email</th>
                <td class="has-text-centered">{{ application.submitter.email }}</td>
              </tr> -->
            </tbody>
          </table>
          <span v-if="application.questionTellUsAboutYourOrganization.length > 0" >
          <h5 class="title is-5">Tell us about your organization</h5>
          <p class="content">{{ application.questionTellUsAboutYourOrganization }}</p>
          </span>
         <br>
          <span v-if="application.questionWhichTypeOfFunding.length > 0" >
          <h5 class="title is-5">Which type of funding do you think is the best fit for the appeal made in this proposal?</h5>
          <p class="content">{{ application.questionWhichTypeOfFunding }}</p>
          </span>
         <br>
          <span v-if="application.questionTellUsAboutProposal.length > 0" >
          <h5 class="title is-5">Tell us about your proposal</h5>
          <p  class="content">{{ application.questionTellUsAboutProposal }}</p>
          </span>
         <br>
          <span v-if="application.questionAboutProposalAuthor" >
            <h5 class="title is-5">Tell us about the proposal author</h5>
            <p class="content">{{ application.questionAboutProposalAuthor }}</p>
          </span>
          <br />
          <span v-if="application.questionChangesToApproach.length > 0" >
          <h5 class="title is-5">Have there been major changes to the way you approach funders and/or write proposals since your last submission?</h5>
          <p class="content">{{ application.questionChangesToApproach }}</p>
          </span>
         <br>
          <span v-if="application.questionWhereElseHaveYouSubmitted.length > 0" >
          <h5 class="title is-5">Where else have you submitted this? Or where do you plan to submit?</h5>
          <p class="content">{{ application.questionWhereElseHaveYouSubmitted }}</p>
          </span>
         <br>
          <span v-if="application.questionWhyRejected.length > 0" >
          <h5 class="title is-5">If they said no, why do you think it was rejected?</h5>
          <p class="content">{{ application.questionWhyRejected }}</p>
          </span>
         <br>
          <span v-if="application.questionAdditionalComments.length > 0" >
          <h5 class="title is-5">Any additional comments?</h5>
          <p class="content">{{ application.questionAdditionalComments }}</p>
          </span>
         <br>
          <span v-if="application.questionKujalinkProfile">
            <h5 class="title is-5">What is your KujaLink profile?</h5>
            <p class="content">
              <a :href="application.questionKujalinkProfile" target="_blank">
                {{ application.questionKujalinkProfile }}
              </a>
            </p>
          </span>
         <br />
          <h5 class="title is-5">Provide us a link to your application</h5>
          <p class="content">
            <a v-if="application.proposal" :href="application.proposal" target="_blank">
              <button class="button">Download Proposal</button>
            </a>
            <a v-if="application.proposalLink" :href="application.proposalLink" target="_blank">
              <button class="button">Link to Proposal</button>
            </a>
          </p>
        </div>
      </div>
      <div class="column" v-if="showEvaluation" :class="{ 'is-half': showProposal }">
        <div class="box" style="background-color: #fbdbd1" v-if="evaluation.commitments.length > 0">
          <h5 class="title is-5">Your Follow-Ups</h5>
          <div class="content">
            <ol>
              <li v-for="commitment in evaluation.commitments" :key="commitment.id">
                {{ commitment.description }}
              </li>
            </ol>
          </div>
        </div>
        <h4 class="title is-4">Your Evaluation</h4>
        <div v-for="(section, index) in evaluation.sections" :key="index" class="box">
          <div class="level">
            <div class="level-left">
              <div class="level-item">
                <h5 class="title is-5" style="maxWidth: 12rem;">{{ section.title }}</h5>
		<!--
                <span
                  :class="{
                    'has-text-primary': sectionCompletePercentage(section, evaluation) !== 1,
                    'has-text-success': sectionCompletePercentage(section, evaluation) === 1,
                  }"
                  style="padding: 0 15px"
                  ><i
                    class="fa fa-check"
                    v-if="sectionCompletePercentage(section, evaluation) === 1"
                  ></i>
                  {{ (sectionCompletePercentage(section, evaluation) * 100).toFixed(0) }}% Complete
                </span>
		-->
              </div>
            </div>
            <div class="level-right">
              <div class="level-item">
                <button class="button" @click="toggleHiddenSection(section)">
                  {{ shownSections.includes(section.id) ? 'Hide' : 'Show' }} Section
                </button>
              </div>
            </div>
          </div>
          <progress
            class="progress is-small"
            :class="{
              'is-primary': sectionCompletePercentage(section, evaluation) !== 1,
              'is-success': sectionCompletePercentage(section, evaluation) === 1,
            }"
            :value="sectionCompletePercentage(section, evaluation)"
            max="1"
          >
          </progress>
          <div
            class="field"
            v-for="response in evaluation.responses"
            v-if="response.questionRef.section === section.id && shownSections.includes(section.id)"
            :key="response.id"
          >
            <Question
              style="margin: 20px 0"
              :response="response"
              :loading="response.isLoading"
              @change="responseChanged(response)"
            ></Question>
          </div>
        </div>
        <div class="field">
          <div class="control">
            <button class="button is-primary" @click="submitResponses()">
              I'm Finished
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="modal is-active" v-if="introModalShown">
      <div class="modal-background"></div>
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title">Make a Follow-Up commitment!</p>
          <button class="delete" @click="toggleModal"></button>
        </header>
        <section class="modal-card-body">
          <div class="field">
            <label class="label">How can you help?</label>
            <div class="control">
              <textarea class="textarea" v-model="modalCommitmentDescription"></textarea>
            </div>
          </div>
        </section>
        <footer class="modal-card-foot">
          <button class="button is-primary" @click="submitCommitments(modalCommitmentDescription)">
            Submit
          </button>
          <button class="button" @click="toggleModal">Cancel</button>
        </footer>
      </div>
    </div>
    <nav class="navbar is-fixed-bottom is-light">
      <div class="container">
        <div class="navbar-brand">
          <span class="navbar-item"
            ><router-link to="/"
              ><h5 class="title is-5 has-text-white-bis">Unfunded List</h5></router-link
            ></span
          >
        </div>
        <div class="navbar-end">
          <div class="navbar-item">
            <h6 class="title is-6">
              Think you can help? Let us know by making a follow-up commitment to
              {{ application.organization.name }}.
            </h6>
          </div>
          <div class="navbar-item">
            <div class="buttons">
              <button                class="button is-primary is-outlined"                @click="toggleModal(INTRODUCTION_OFFER)"              >
                Introduction Offer
              </button>
              <button                class="button is-primary is-outlined"                @click="toggleModal(DIRECT_CONVERSATION)"              >
                Direct Conversation
              </button>
              <button                class="button is-primary is-outlined"                @click="toggleModal(RESOURCE_SUGGESTION)"              >
                Resource Suggestion
              </button>
            </div>
          </div>
        </div>
      </div>
    </nav>
  </div>
</template>

<script>
import Commitment from '@/services/commitments/'
import Application from '@/services/applications/'
import Evaluation from '@/services/evaluations/'
import Question from '@/components/question/'
import EvaluationResponse from '@/services/evaluationResponses/'

import { mapState } from 'vuex'

export default {
  components: { Question },
  data() {
    return {
      modalCommitmentDescription: '',
      modalCommitmentName: '',
      applicationId: null,
      introModalShown: false,
      evaluationDataLoaded: false,
      applicationDataLoaded: false,
      application: null,
      evaluation: null,
      showProposal: true,
      showEvaluation: true,
      shownSections: [],
      applicationAssignedToEvaluator: true,
      INTRODUCTION_OFFER: Commitment.INTRODUCTION_OFFER,
      DIRECT_CONVERSATION: Commitment.DIRECT_CONVERSATION,
      RESOURCE_SUGGESTION: Commitment.RESOURCE_SUGGESTION,
    }
  },
  computed: {
    ...mapState(['userLoggedInStatus', 'user']),
    canSubmit() {
      if (this.evaluationDataLoaded === false) {
        return false
      }
      return this.evaluation.responses.every(response => response.response)
    },
  },
  created() {
    this.applicationId = this.$route.params.applicationId
    Application.api.get(this.applicationId).then(data => {
      this.application = data
      this.applicationAssignedToEvaluator = this.application.evaluators.includes()
      this.applicationDataLoaded = true
    })
    Application.api.createOrReturnEvaluation(this.applicationId).then(data => {
      let initialEvaluation = data
      initialEvaluation.responses.forEach(response => {
        response.isLoading = false
      })
      initialEvaluation.responses.sort((a, b) => a.questionRef.order - b.questionRef.order)
      initialEvaluation.sections.forEach(section => {
        this.shownSections.push(section.id)
      })
      this.evaluation = initialEvaluation
      this.evaluationDataLoaded = true
    })
  },
  methods: {
    responseChanged(componentResponse) {
      componentResponse.isLoading = true
      const fields = ['response','includeInReport']
      if (componentResponse.questionRef.choices == null)
      {
        componentResponse.includeInReport = true;
      }else{
        componentResponse.includeInReport = false;
      }
      EvaluationResponse.api.update(componentResponse, fields).then(() => {
        Evaluation.api.get(this.evaluation.id).then(data => {
          this.evaluation = data
          this.evaluation.responses.forEach(response => {
            response.isLoading = false
          })
        })
      })
    },
    toViewEvaluationVersion(id) {
      const url = `/staff/application/${id}/`
      window.open(url, '_parent')
    },

    toggleModal(name='') {
      this.introModalShown = !this.introModalShown
      this.modalCommitmentDescription = ''
      this.modalCommitmentName = name
    },
    submitResponses() {
      this.submitButtonLoading = true
      let fields = ['response','includeInReport']
      this.evaluation.responses.forEach(response => {
        if (response.questionRef.choices == null)
        {
          response.includeInReport = true;
        }else{
          response.includeInReport = false;
        }
        EvaluationResponse.api.update(response, fields)
      })
      this.submitButtonLoading = false
      this.$Alert.alert({
        type: 'info',
        message: `
                      <p>Application Submitted. Thank you!.</p>
                    `,
        timeout: 6000,
      })
      this.$router.push({ name: 'ApplicationReview' })
    },
    submitCommitments() {
      let evaluationId = this.evaluation.id
      let commitment = Commitment.create({
        name: this.modalCommitmentName,
        description: this.modalCommitmentDescription,
        evaluation: evaluationId,
      })
      Commitment.api.create(commitment).then(() => {
        Application.api.createOrReturnEvaluation(this.applicationId).then(data => {
          this.evaluation = data
          this.evaluationDataLoaded = true
        })
        this.toggleModal()
      })
    },
    sectionCompletePercentage(section, evaluation) {
      let sectionResponses = evaluation.responses.filter(
        response => response.questionRef.section === section.id,
      )
      let completedSectionResponses = sectionResponses.filter(response => response.response)
      let sectionCount = sectionResponses.length
      let completedSectionCount = completedSectionResponses.length
      // return sectionCount
      if (completedSectionCount > 0) {
        return completedSectionCount / sectionCount
      }
      return 0
    },
    toggleHiddenSection(section) {
      if (this.shownSections.includes(section.id)) {
        this.shownSections = this.shownSections.filter(shownSection => shownSection !== section.id)
      } else {
        this.shownSections.push(section.id)
      }
    },
  },
}
</script>

<style scoped>
.propTable {
  word-break: break-word;
}
</style>
